import {RouteRecordRaw, useRoute} from "vue-router";
import LayoutView from "@/views/share/LayoutView.vue";
import {session} from "@/model/session";
import {message} from "ant-design-vue";
import {api} from "@/lib/api";
import {IActivityMetadata} from "@/model/activity";
import {UserAgent} from "@/model/user_agent";
import EditorHeader from "@/views/editor/EditorHeader.vue";
import EditorSide from "@/views/editor/EditorSide.vue";
import tier_group from "@/views/editor/version/tier_group";
import {defineComponent, h} from "vue";
import {AEditor, GenActivityMeta, INewEditor} from "@/views/editor/service/editor";

const editors: { [key: string]: () => Promise<unknown> } = {...tier_group}

const primaryTag = (tags: string[]): string => {
    for (let i = tags.length - 1; i >= 0; i--) {
        if (tags[i].startsWith("a-")) return tags[i];
    }
    throw new Error('模板标签异常');
}

export default <Array<RouteRecordRaw>>[
    {
        path: '/editor',
        meta: {auth: true},
        component: LayoutView,
        children: [
            {
                path: '',
                meta: {auth: true},
                beforeEnter: async (to, from, next) => {
                    const material = await session.material()
                    const ua = to.meta.agent as UserAgent
                    to.meta.material = material
                    try {
                        const done = message.loading('加载中', 0)
                        const am = to.query.tags
                            ? await GenActivityMeta(ua, material, to.query.tags as string[], to.query.theme_id as string | null).finally(done)
                            : await api<void, IActivityMetadata>({url: `user/${ua.meta.account.agent_id}/activity/` + to.query.activity_id}).finally(done)
                        if (!editors[primaryTag(am.tags as string[])]) throw new Error('编辑器暂不支持此类型')
                        const m = await editors[primaryTag(am.tags as string[])]() as { default: INewEditor }
                        to.meta.editor = new m.default(ua, material, am)
                        return next()
                    } catch (error) {
                        console.log(error)
                        if (error instanceof Error) message.error(error.message)
                        return next('/');
                    }
                },
                components: {
                    default: defineComponent({setup: () => () => h((useRoute().meta.editor as AEditor).active.content.layer)}),
                    header: EditorHeader,
                    side: EditorSide,
                },
            },
        ]
    }
]

